



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component
export default class DropItemSelector extends Vue {
    @Prop({ default: '' }) title!: string;
    @Prop({ default: '' }) valueKey!: string;
    @Prop({ default: '' }) valueName!: string;
    @Prop({ default: () => {return []} }) options!: any[];
    @Prop({ default: () => {return []} }) value!: any[];

    dropValue: any[] = this.value

    @Watch('value')
    changValue(val: any[]) {
        this.dropValue = val
    }

    selectItem (val: any) {
        if (this.dropValue.includes(val[this.valueKey])) {
            this.dropValue.splice(this.dropValue.findIndex((item) => item === val[this.valueKey]), 1)
        } else {
            this.dropValue.push(val[this.valueKey])
        }
    }

    resetFunc () {
        this.dropValue = []
    }

    sureFunc () {
        this.$emit('input', this.dropValue)
        this.$emit('confirmFunc')
        ;(this.$refs.item as any).toggle()
    }
}
